import { render, staticRenderFns } from "./ResetIcon.vue?vue&type=template&id=096fc7e4&"
import script from "./ResetIcon.vue?vue&type=script&lang=js&"
export * from "./ResetIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports